<ng-container *ngIf="feedback; else loading">
  <ng-container *ngIf="feedback.reward as reward; else noReward">
    <div class="d-flex justify-content-center">
      <div class="d-flex flex-column page-container">
        <div class="card m-3 h-100">
          <section class="d-flex title m-3 px-1 pb-3">
            <span>Terima kasih telah mengisi customer survey Gurih 7</span>
          </section>
          <section class="d-flex flex-column align-items-center reward mx-3 px-3 pb-3">
            <span>Anda mendapatkan hadiah:</span>
            <img [src]="reward.rewardImage" class="reward-img my-3"/>
            <span class="px-5">{{ reward.rewardDescription }}</span>
            <strong class="px-5 py-3">{{ reward.rewardCode }}</strong>
          </section>
          <section class="d-flex flex-column claim align-items-center m-3">
            <span>Bagaimana cara menerima hadiah Anda?</span>
            <div class="d-flex flex-row list-item-claim align-items-center mt-3 w-100">
              <div class="claim-icon m-1 p-3">
                <mat-icon>add_a_photo</mat-icon>
              </div>
              <span class="mx-3">Screenshot halaman ini</span>
            </div>
            <div class="d-flex flex-row list-item-claim align-items-center mt-3 w-100">
              <div class="claim-icon m-1 p-3">
                <mat-icon>supervisor_account</mat-icon>
              </div>
              <span class="mx-3">Tunjukkan kepada staff Gurih 7 di kedatangan Anda berikutnya</span>
            </div>
            <div class="d-flex flex-row list-item-claim align-items-center mt-3 w-100">
              <div class="claim-icon m-1 p-3">
                <mat-icon>card_giftcard</mat-icon>
              </div>
              <span class="mx-3">Terima hadiah Anda</span>
            </div>
          </section>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #noReward>
    <div class="h-100 d-flex justify-content-center align-items-center flex-column no-reward">
      <img src="assets/images/thank-you.png" />
      <section class="d-flex flex-column align-items-center text-center m-3">
        <h3>Terima kasih telah mengisi customer survey Gurih 7</h3>
        <p>Penilaianmu bermanfaat untuk terus meningkatkan kualitas makanan di Gurih 7</p>
      </section>
    </div>

  </ng-template>
</ng-container>
<ng-template #loading>
  <div class="d-flex align-items-center justify-content-center h-100 w-100">
    <div class="loader"></div>
  </div>
</ng-template>
